// import { cookieStore } from 'cookie-store';
//
// if (!window.cookieStore) {
//   // 如果不存在或不是有效的 CookieStore，尝试设置兼容性实现
//   console.info('使用兼容性 CookieStore 实现');
//   // 使用 Object.defineProperty 来安全地设置属性
//   Object.defineProperty(window, 'cookieStore', {
//     value: cookieStore,
//     writable: false,
//     configurable: true,
//     enumerable: true,
//   });
// }
import { initCookieStore } from './cookie-store';

initCookieStore();
// eslint-disable-next-line import/order
import { default as Cookies } from 'universal-cookie';

/**
 * 目前华龙芯平台的 Token 规则
 */
export const TOKENS_RE = String.raw`[\dA-Za-z]{8}(-[\dA-Za-z]{4}){3}-[\dA-Za-z]{12}`;

/**
 * Define cookies handler instance for tokens by `universal-cookie`
 */
export const TOKENS_COOKIE = new Cookies(null, {
  secure: location.protocol === 'https:',
  domain: /^(?:\d+\.){3}\d+$/.test(window.location.hostname)
    ? undefined
    : window.location.hostname.replace(/^(.*\.)?(\w+\.\w+)$/, '.$2'),
  path: '/',
});

/**
 * 判断目标值是不是一个有效的系统令牌
 *
 * @param payload - 目标值
 */
export function isSystemToken(payload: unknown): payload is string {
  if (typeof payload !== 'string') {
    return false;
  }
  return new RegExp(`^${TOKENS_RE}$`).test(payload);
}

/**
 * 判断目标值是不是一个授权令牌
 *
 * @param payload - 目标值
 */
export function isAccessToken(payload: unknown): payload is string {
  if (typeof payload !== 'string') {
    return false;
  }
  return new RegExp(`^bearer ${TOKENS_RE}$`).test(payload);
}

/**
 * 判断目标值是不是一个自动刷新值
 *
 * @param payload - 目标值
 */
export function isAutoRefresh(payload: unknown): payload is string {
  if (typeof payload !== 'string') {
    return false;
  }
  return payload === 'true';
}
